import { render, staticRenderFns } from "./DuplicateCodeWarningModal.vue?vue&type=template&id=7307166c&scoped=true"
import script from "./DuplicateCodeWarningModal.vue?vue&type=script&lang=js"
export * from "./DuplicateCodeWarningModal.vue?vue&type=script&lang=js"
import style0 from "./DuplicateCodeWarningModal.vue?vue&type=style&index=0&id=7307166c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7307166c",
  null
  
)

export default component.exports